import React, { useState } from 'react';
import { Card, Nav, NavItem, NavLink, TabContent, TabPane,Row,Col } from 'reactstrap';
import classnames from 'classnames';
import { Link} from "react-router-dom";
import LeadDetails from '../components/LeadDetails';




const LeadTab = ({lead=[]})=> {
    const [activeTab, setActiveTab] = useState('1');

    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }
    return (
        <React.Fragment>
            <Card className="mb-0">
                <Nav pills justified  role="tablist">
                    
                  

                    <NavItem>
                        <NavLink
                            to="#"
                            className={classnames({ active: activeTab === '4' })}
                            onClick={() => { toggle('4'); }}>
                            <i className="mdi mdi-account-circle-outline font-size-20"></i>
                            <span className="d-none d-sm-block">Crear Como</span>
                        </NavLink>
                    </NavItem>
                </Nav>

                <TabContent className="p-4" activeTab={activeTab}>
                  
                   
                   
                    
                    <TabPane id="contactsDetails" role="tabpanel" tabId="4">

                       <LeadDetails lead = {lead}/>
                       </TabPane>

                </TabContent>
                <Row className="col-lg-12 justify-content-center">
                    <Col className="mb-3" md={1}>
                      <Link className="btn btn-secondary " to={`/leads`}>
                        Volver
                      </Link>
                    </Col>
                  </Row>
            </Card>
        </React.Fragment>
    );
}

export default LeadTab;